var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Material from "../../node_modules/grimoirejs-fundamental/ref/Material/Material";
import MaterialFactory from "grimoirejs-fundamental/ref/Material/MaterialFactory";
import GLTFConstantConvert from "./ConstantConverter";
export default class MaterialParser {
    static parse(tf, matKey, rr, textures) {
        return __awaiter(this, void 0, void 0, function* () {
            const material = tf.materials[matKey];
            if (material.extensions && material.extensions.KHR_materials_common) {
                return this._parseMaterialCommon(tf, matKey, textures);
            }
            else {
                if (MaterialFactory.registerdHandlers[material.technique] === void 0) {
                    const techniqueRecipe = yield this._convertIntoTechniqueRecipe(tf, matKey, rr);
                    MaterialFactory.addMaterialType(material.technique, (factory) => {
                        return new Material(factory.gl, techniqueRecipe);
                    });
                }
                const result = {
                    type: material.technique,
                    class: "gltf-" + tf.id + "-" + matKey
                };
                for (let key in material.values) {
                    const v = material.values[key];
                    const teq = tf.techniques[material.technique];
                    const tv = teq.parameters[key];
                    let valName = "";
                    for (let uKey in teq.uniforms) {
                        if (teq.uniforms[uKey] === key) {
                            valName = uKey;
                        }
                    }
                    if (tv.type !== WebGLRenderingContext.SAMPLER_2D) {
                        result[valName] = material.values[key];
                    }
                    else {
                        result[valName] = textures[material.values[key]];
                    }
                }
                return result;
            }
        });
    }
    static _convertIntoTechniqueRecipe(tf, matKey, resourceResolver) {
        return __awaiter(this, void 0, void 0, function* () {
            const mat = tf.materials[matKey];
            const technique = tf.techniques[mat.technique];
            const program = tf.programs[technique.program];
            let techniqueRecipe = {
                passes: [
                    {
                        vertex: yield resourceResolver.loadShader(tf.shaders[program.vertexShader]),
                        fragment: yield resourceResolver.loadShader(tf.shaders[program.fragmentShader]),
                        attributes: this._asAttributeInfo(technique),
                        uniforms: this._asUniformInfo(technique),
                        macros: {},
                        states: this._getState(technique)
                    }
                ],
                drawOrder: "UseAlpha"
            };
            return {
                default: techniqueRecipe
            };
        });
    }
    static _asAttributeInfo(technique) {
        const result = {};
        for (let key in technique.attributes) {
            const attrGlue = technique.attributes[key];
            const paramInfo = technique.parameters[attrGlue];
            result[key] = {
                name: key,
                semantic: paramInfo.semantic,
                type: paramInfo.type
            };
        }
        return result;
    }
    static _asUniformInfo(technique) {
        const result = {};
        for (let key in technique.uniforms) {
            const uniGlue = technique.uniforms[key];
            const paramInfo = technique.parameters[uniGlue];
            const annotations = {};
            if (paramInfo.value) {
                annotations["default"] = paramInfo.value;
            }
            result[key] = {
                name: key,
                semantic: paramInfo.semantic || "USER_VALUE",
                type: paramInfo.type,
                attributes: annotations
            };
        }
        return result;
    }
    static _getState(technique) {
        const result = {
            enable: [],
            functions: {
                blendColor: [0, 0, 0, 0],
                cullFace: [WebGLRenderingContext.BACK],
                blendFuncSeparate: [WebGLRenderingContext.ONE, WebGLRenderingContext.ZERO, WebGLRenderingContext.ONE, WebGLRenderingContext.ZERO],
                blendEquationSeparate: [WebGLRenderingContext.FUNC_ADD, WebGLRenderingContext.FUNC_ADD],
                lineWidth: [1],
                frontFace: [WebGLRenderingContext.CCW],
                depthRange: [0, 1],
                depthFunc: [WebGLRenderingContext.LESS]
            }
        };
        const st = technique.states;
        if (st.enable) {
            for (let item of st.enable) {
                result.enable.push(item);
            }
        }
        return result;
    }
    static _parseMaterialCommon(tf, matKey, textures) {
        const material = tf.materials[matKey];
        const cmatData = material.extensions.KHR_materials_common;
        const matValues = cmatData.values;
        switch (cmatData.technique) {
            case "PHONG":
            case "BLINN":
                const result = {
                    type: "gltf-unlit",
                    class: "gltf-" + tf.id + "-" + matKey
                };
                this._setAsColorOrTexture(result, textures, matValues.ambient, "ambient", "ambientTexture");
                this._setAsColorOrTexture(result, textures, matValues.diffuse, "diffuse", "diffuseTexture");
                this._setAsColorOrTexture(result, textures, matValues.specular, "specular", "specularTexture");
                this._setAsColorOrTexture(result, textures, matValues.specular, "specular", "specularTexture");
                this._setAsColorOrTexture(result, textures, matValues.emission, "emission", "emissionTexture");
                result["transparency"] = matValues["transparency"];
                result["shininess"] = matValues["shininess"];
                return result;
            default:
                throw new Error(`Unsupported common material technique ${cmatData.technique}`);
        }
    }
    static _setAsColorOrTexture(result, textures, value, nameOnColor, nameOnTexture) {
        if (Array.isArray(value)) {
            result[nameOnColor] = GLTFConstantConvert.asColorValue(value);
        }
        else if (typeof value === "string") {
            result[nameOnTexture] = textures[value];
        }
        else if (value === void 0) {
            return;
        }
        else {
            throw new Error("Unknown type for color registration");
        }
    }
}



// WEBPACK FOOTER //
// ./src/Parser/MaterialParser.ts